import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonGroup, Content, Dialog, DialogContainer, Divider, Flex, Heading, Text as SpectrumText, } from '@adobe/react-spectrum';
import { EditorActions } from 'app/stores/editor/actions';
import { Text } from 'app/views/components/typography/Text';
import { clipboardRenders, saveToClipboardWithToasts, } from 'app/utils/clipboard';
export const ClipboardDialog = () => {
    const dispatch = useDispatch();
    const renderId = useSelector((state) => state.editor.clipboardRender);
    const render = renderId && clipboardRenders.get(renderId);
    const onClearClipboardRender = React.useCallback(() => {
        clipboardRenders.clear();
        dispatch(EditorActions.setClipboardRender(undefined));
    }, [dispatch]);
    const onPlaceInClipboard = React.useCallback(() => {
        onClearClipboardRender();
        if (render) {
            saveToClipboardWithToasts(render, dispatch);
        }
    }, [render, onClearClipboardRender, dispatch]);
    return (React.createElement(DialogContainer, { onDismiss: onClearClipboardRender }, render && (React.createElement(Dialog, null,
        React.createElement(Heading, null, "Copy image to clipboard"),
        React.createElement(Divider, null),
        React.createElement(Content, null,
            React.createElement(Flex, { alignItems: "center", direction: "column", gap: "size-150" },
                React.createElement(SpectrumText, null, "Image is ready and can be copied to clipboard."),
                React.createElement(SpectrumText, null, "Click below to copy image to clipboard"),
                React.createElement(Text, { size: "XS" }, "This is a security requirement on Safari."))),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { variant: "secondary", onPress: onClearClipboardRender }, "Cancel"),
            React.createElement(Button, { variant: "cta", onPress: onPlaceInClipboard }, "Copy to clipboard"))))));
};
